(() => {
  const mq = window.matchMedia('(min-width: 990px)');

  function closeAll(except) {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]')
      .forEach(d => { if (d !== except) d.removeAttribute('open'); });
  }

  function enableHover() {
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(details => {
      let t;

      details.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        clearTimeout(t);
        closeAll(details);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        clearTimeout(t);
        t = setTimeout(() => details.removeAttribute('open'), 150);
      });

      details.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') details.removeAttribute('open');
      });
    });
  }

  enableHover();

  // If you resize across the breakpoint, close menus
  mq.addEventListener?.('change', () => closeAll());
})();
